import { Box } from '@mui/material';
import CardItemDTO from '@src/adapters/dto/card/CardItemDTO';
import { CardModificationDTO } from '@src/adapters/dto/card/CardModificationDTO';
import useCreateCardItemWithInventoryLazy from '@src/adapters/hooks/card/useCreateCardItemWithInventory';

import InventoryAutoComplete from '@src/components/inventory/InventoryAutoComplete';
import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import { useForm, useWatch } from 'react-hook-form';

interface Props {
  cardId: string;
  onItemAdded(cardItem: CardItemDTO, modification: CardModificationDTO): void;
}

interface FormValues {
  inventory: { id: string | null; name: string | null };
}

function InventorySelection({ cardId, onItemAdded }: Props) {
  const { execute } = useCreateCardItemWithInventoryLazy();
  const { enqueueSnackbar } = useSnackbar();
  const { control, reset, setValue } = useForm<FormValues>({
    mode: 'all',
    defaultValues: {
      inventory: {
        id: null,
        name: null,
      },
    },
  });

  const selectedItem = useWatch({ control, name: 'inventory' });

  useEffect(() => {
    if (selectedItem && selectedItem.id) {
      execute({
        cardId,
        inventoryId: selectedItem.id,
      }).then((result) => {
        onItemAdded(result.cardItem, result.modification);
        reset();
        enqueueSnackbar('Item Added', { variant: 'success' });
      });
    }
  }, [enqueueSnackbar, execute, onItemAdded, selectedItem, reset, cardId]);

  return (
    <Box
      sx={(theme) => ({
        padding: theme.spacing(3),
      })}>
      <InventoryAutoComplete
        control={control}
        name="inventory"
        label="Add Item"
        allowAdd={false}
        setValue={setValue}
      />
    </Box>
  );
}

export default InventorySelection;
